import { api2 } from "../controllers/api";

export const getAllHubsListAPI = async (hubId) => {
  try {
    const url = `/hub?limit=100${hubId ? `&hub_id=${hubId}` : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getChildHubListAPI = async (parentHubId) => {
  try {
    const url = `/hub/childHub?parent_hub_id=${parentHubId}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
